import { FC, useState } from "react";
import { marked } from "marked";
import Accordion from "../Accordion";
import * as S from "./styles";
import { Entry, Asset } from "contentful";
import { ContentfulTextPair } from "../../lib/contentfulTypes";

interface FAQProps extends Entry {
  fields: {
    expandFirstQuestion: boolean;
    heading?: string;
    questions?: [ContentfulTextPair];
    defaultImage?: Asset;
    imageContentModule?: boolean;
  },
  parentProps: {
    theme: string;
    brand: string;
  }
}

const FAQ: FC<FAQProps> = ({ fields, parentProps }) => {
  const { expandFirstQuestion, heading, questions, defaultImage, imageContentModule } = fields;
  const { theme, brand } = parentProps;
  const initialId = (expandFirstQuestion && questions) ? questions[0].sys.id : '';
  const [openEntryId, setOpenEntryId] = useState(initialId);

  const toggleOpen = (entryId: string) => {
    const id = (entryId == openEntryId) ? '' : entryId;
    setOpenEntryId(id);
  }

  const getImageForQuestion = (entry: ContentfulTextPair) => {
    if (entry?.fields?.optionalImage) {
      return entry.fields.optionalImage.fields.file?.url;
    }
    return defaultImage?.fields.file?.url;
  };

  return (
    <S.OuterContainer $theme={theme} $imageContentModule={!!imageContentModule}>
      <S.Container>
        <S.FAQContentWrapper $imageContentModule={!!imageContentModule}>
          {imageContentModule && (
            <S.ImageContainer $imageContentModule={!!imageContentModule}>
              {openEntryId ? (
                <img
                  src={`https:${getImageForQuestion(questions?.find((q) => q.sys.id === openEntryId)!) || ''}`}
                  alt="FAQ illustration"
                />
              ) : (
                <img src={`https:${defaultImage?.fields.file?.url}`} alt="Default FAQ illustration" />
              )}
            </S.ImageContainer>
          )}
          <S.FAQContent $imageContentModule={!!imageContentModule}>
            {heading && <h3>{heading}</h3>}
            {questions?.map((entry, index) => {
              const { id } = entry.sys;
              const { primaryText, secondaryText } = entry.fields;
              const isOpen = (id == openEntryId);
              const isFirst = (index == 0);
              const isLast = (index == questions.length - 1);
  
              return (
                <S.Entry key={id} $isFirst={isFirst} $isLast={isLast} $theme={theme} $imageContentModule={!!imageContentModule} $brand={brand}>
                  <S.QuestionWrap onClick={() => toggleOpen(id)} $theme={theme} $imageContentModule={!!imageContentModule} $brand={brand} $isOpen={isOpen}>
                    <S.Question $isOpen={isOpen} $theme={theme} $imageContentModule={!!imageContentModule} $brand={brand}>
                      {primaryText}
                    </S.Question>
                  </S.QuestionWrap>
                  <Accordion isOpen={isOpen}>
                    {secondaryText && (
                      <S.Answer
                        $brand={brand}
                        $theme={theme}
                        $imageContentModule={!!imageContentModule}
                        dangerouslySetInnerHTML={{ __html: marked.parse(secondaryText) }}
                      />
                    )}
                  </Accordion>
                </S.Entry>
              );
            })}
          </S.FAQContent>
        </S.FAQContentWrapper>
      </S.Container>
    </S.OuterContainer>
  );
};

export default FAQ;